// TODO something smarter..
interface ITagTranslations {
  [key: string]: string;
}

/* TODO i18n */
export function translateTag(tag: string, locale: string): string {
  const isTranslations: ITagTranslations = {
    interview: 'Viðtal',
    ha: 'HA',
    submitted: 'Aðsent',
  };

  if (locale === 'is') {
    if (tag in isTranslations) {
      return isTranslations[tag];
    }
  }

  return tag;
}
